import { combineReducers } from 'redux';

export function error(state = null, action) {
    switch (action.type) {
        case 'SONG_PICKED_ERROR':
            return action.error;

        case 'SONG_PICKED_RESET':
            return null;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case 'SONG_PICKED_LOADING':
            return action.loading;

        case 'SONG_PICKED_RESET':
            return false;

        default:
            return state;
    }
}

export function data(state = {}, action) {
    switch (action.type) {
        case 'SONG_PICKED_SUCCESS':
            return action.data;

        case 'SONG_PICKED_RESET':
            return {};

        default:
            return state;
    }
}

export default combineReducers({ error, loading, data });



// WEBPACK FOOTER //
// ./src/reducers/song/picked.js